import { render, staticRenderFns } from "./BaikalAttractionsZab.vue?vue&type=template&id=1b28dbea"
import script from "./BaikalAttractionsZab.vue?vue&type=script&lang=js"
export * from "./BaikalAttractionsZab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports